// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3c12900a","453":"c709444d","553":"34d42bb5"}[chunkId] + ".chunk.js";
};